import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "loading"
}

import { ref, computed, onMounted, provide } from 'vue'
import { useAuthStore } from '@/views/Authentication/store'
import { useThemeStore } from '@/stores/theme'
import { useGlobalStore } from '@/stores/global'
import { useDisplay } from 'vuetify'


import AppBar2 from './components/AppBar2.vue'
import AppSidebar2 from './components/AppSidebar2.vue'

export default /*@__PURE__*/_defineComponent({
  __name: 'DefaultLayout',
  setup(__props, { expose: __expose }) {

const themeStore = useThemeStore()
const authStore = useAuthStore()
const globalStore = useGlobalStore()
const { mobile } = useDisplay()

const drawer = ref<boolean>(true)
const isMobileLocal = ref<boolean>(false)

const currentTheme = computed(() => themeStore.currentTheme)
const userProfile = computed(() => authStore.userProfile)
console.log('User Profile:', userProfile.value)
const loadData = computed(() => globalStore.loadData)

const toggleDrawer = () => {
  drawer.value = !drawer.value
}

const hideDrawer = () => {
  drawer.value = false
}

__expose({ hideDrawer })
provide('hideDrawer', hideDrawer)

onMounted(() => {
  window.addEventListener('resize', () => {
    isMobileLocal.value = window.innerWidth <= 500
  })
  isMobileLocal.value = window.innerWidth <= 500
  globalStore.setLoadData(true)
  if (isMobileLocal.value) drawer.value = false
})

return (_ctx: any,_cache: any) => {
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "bg-background",
    elevation: "0"
  }, {
    default: _withCtx(() => [
      _createVNode(AppBar2, {
        "toggle-drawer": toggleDrawer,
        user: userProfile.value,
        theme: currentTheme.value,
        onLogout: _unref(authStore).logOut,
        onToggleTheme: _unref(themeStore).toggleTheme
      }, null, 8, ["user", "theme", "onLogout", "onToggleTheme"]),
      _createVNode(AppSidebar2, {
        drawer: drawer.value,
        theme: currentTheme.value,
        isMobile: _ctx.$vuetify.display.mobile,
        "onUpdate:drawer": _cache[0] || (_cache[0] = ($event: any) => (drawer.value = $event)),
        "user-profile": userProfile.value,
        onLogout: _ctx.handleLogout
      }, null, 8, ["drawer", "theme", "isMobile", "user-profile", "onLogout"]),
      _createVNode(_component_v_main, null, {
        default: _withCtx(() => [
          (loadData.value)
            ? (_openBlock(), _createBlock(_component_v_container, { key: 0 }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    _renderSlot(_ctx.$slots, "default")
                  ]),
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "footer-text" }, [
                    _createTextVNode(" Desarrollado por TorcazaDev "),
                    _createElementVNode("span", { class: "heart-icon" }, "®"),
                    _createTextVNode(" Todos los derechos reservados ")
                  ], -1))
                ]),
                _: 3
              }))
            : (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_progress_circular, {
                  size: "60",
                  class: "mx-auto my-auto",
                  indeterminate: "",
                  color: "primary"
                })
              ]))
        ]),
        _: 3
      })
    ]),
    _: 3
  }))
}
}

})